import { Component, Input, OnInit } from '@angular/core';
import { ChatHttpService } from '../../services/chat-http.service';
import { ImageGallery } from '../../type/employee.interface';
import { GalleryImageService } from '../../services/gallery-image.service';
import { ChatService } from '../../services/chat.service';

@Component({
  selector: 'app-gallery-image',
  templateUrl: './gallery-image.component.html',
  styleUrls: ['./gallery-image.component.scss']
})
export class GalleryImageComponent implements OnInit {

  @Input() moderation = false;
  @Input() images: ImageGallery[] = [];
  currentImageIndex = 0;
  constructor(private galleryService: GalleryImageService) { }

  ngOnInit(): void {
    this.images = this.galleryService.images$.getValue();
    this.currentImageIndex = this.galleryService.openImageIndex;
  }

  nextImage() {
    let indexTarget = this.currentImageIndex + 1;
    const max = this.images.length;
    console.log(indexTarget);
    if (max <= indexTarget) {
      indexTarget = 0;
      // return;
    }
    this.currentImageIndex = indexTarget;
  }

  prevImage() {
    let indexTarget = this.currentImageIndex - 1;
    console.log(indexTarget);
    if (0 > indexTarget) {
      indexTarget = this.images.length - 1;
      // return;
    }
    this.currentImageIndex = indexTarget;
  }

  close() {
    this.galleryService.closeGallery();
  }
}
